// extracted by mini-css-extract-plugin
export default {"wrapper":"ReportPeriod_wrapper__8xcwq","dateWrapper":"ReportPeriod_dateWrapper__u2r+5","dateSeparator":"ReportPeriod_dateSeparator__wY5SF"};